module.exports = __webpack_public_path__ + "static/img/powered-by-mangopay.90dee3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/powered-by-mangopay.png
// module id = 727
// module chunks = 1